import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router';
import { ProjectId } from 'api/models';
import { Modal } from 'components/atoms/modal';
import { useActiveProjectConversation } from '../../../../proj-conversation-hooks';
import { UpdateConversationForm } from '../update-conversation-form';

interface Props {
  isVisible: boolean;
  onCancel: () => void;
}
export const UpdateConversationModal: FC<Props> = ({
  isVisible,
  onCancel: onClose,
}) => {
  const activeConversation = useActiveProjectConversation();
  const { projectId: projectIdFromRoute } = useParams<{ projectId: string }>();
  const projectId = Number(projectIdFromRoute);

  return (
    <Modal
      width={462}
      visible={isVisible}
      confirmLoading={false}
      onCancel={onClose}
      footer={null}
      title={<FormattedMessage id="projects.conversations.update" />}
    >
      {activeConversation ? (
        <UpdateConversationForm
          onSuccess={onClose}
          activeConversation={activeConversation}
          projectId={ProjectId(projectId)}
        />
      ) : null}
    </Modal>
  );
};
